import React from "react";
import PropTypes from "prop-types";
import { Box, Switch, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    transition:
      "border-color 120ms ease, background-color 120ms ease, box-shadow 120ms ease",
    "&:hover": {
      borderColor: theme.palette.primary.light,
    },
  },
  active: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.action.selected,
  },
  text: {
    minWidth: 0,
    flex: 1,
    paddingTop: theme.spacing(0.5),
  },
  label: {
    fontWeight: 500,
    fontSize: "0.92rem",
    lineHeight: 1.3,
    color: theme.palette.text.primary,
  },
  description: {
    color: theme.palette.text.secondary,
    fontSize: "0.8rem",
    marginTop: theme.spacing(0.5),
    lineHeight: 1.5,
  },
  switchCell: {
    marginTop: theme.spacing(-0.5),
    marginRight: theme.spacing(-1),
  },
}));

const ToggleRow = ({
  label,
  description,
  checked,
  name,
  onChange,
  disabled,
}) => {
  const classes = useStyles();
  const rootClass = checked
    ? `${classes.root} ${classes.active}`
    : classes.root;

  return (
    <Box className={rootClass}>
      <Box className={classes.text}>
        <Typography className={classes.label}>{label}</Typography>
        {description && (
          <Typography className={classes.description}>{description}</Typography>
        )}
      </Box>
      <Box className={classes.switchCell}>
        <Switch
          checked={checked}
          onChange={onChange}
          name={name}
          color="primary"
          disabled={disabled}
        />
      </Box>
    </Box>
  );
};

ToggleRow.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default ToggleRow;
